import React,{useState,useEffect} from "react";
import {
    Box, Button, ButtonGroup, Card, CardActions, CardContent, CardMedia, CircularProgress,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography
} from "@mui/material";
import Menu from "./Menu";
import axios from "axios";
import SuccessMsg from "./msg/SuccessMsg";
import ErrorMsg from "./msg/ErrorMsg";

const Productlist = ()=>{
    const [loading , setLoding] = useState(true);
    const [update , setUpdate] = useState(false);
    const [productList , setProductList] = useState([]);
    const [dialogAddtofactor , setDialogAddtofactor] = useState(false);
    const [selectedCount , setSelectedCount] = useState("");
    const [selectedTitle , setSelectedTitle] = useState("");
    const [selectedId , setSelectedId] = useState("");
    const [orderCount , setOrderCount] = useState("");
    const [errorMsg , setErrorMsg] = useState("");
    const [successMsg , setSuccessMsg] = useState("");

    useEffect(()=>{
        const data = {
            token : "2231sadafawefawef",
        }
        axios.post("https://app.tizro.ir/api/get_product.php",
            data,
            {
            headers: {
                'Content-Type': 'application/json'
            }})
            .then(response=>{
                if(response.status === 200){
                    setProductList(response.data);
                    setLoding(false);
                }
            })
            .catch(error => console.log(error));
        setUpdate(false);
    },[update]);
    const handle_btn_addtofactor = (count,id,title)=>{
        setSelectedCount(count);
        setSelectedTitle(title);
        setSelectedId(id);
        setOrderCount(count);
        setDialogAddtofactor(true);
    }
    const handle_btn_decreas =()=>{
        if (orderCount - selectedCount >= 1 )
            setOrderCount(orderCount - selectedCount);
        else
            setErrorMsg("کمترین مقدار سفارش "+selectedCount+" عدد می باشد ");
    }
    return(
        <div>
            <Menu/>
            {errorMsg !== '' ? <ErrorMsg message={errorMsg} openn={true} seterrormsg={setErrorMsg}/> : '' }
            {successMsg !== '' ? <SuccessMsg message={successMsg} openn={true} setsuccsmsg={setSuccessMsg} /> : '' }
            <Grid
                columnGap={2}
                container
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{direction:"rtl",marginTop:4}}
                justifyContent="center"
                alignItems="center">
                {productList.map(items => (
                    <Grid>
                        <Card sx={{ width: 340,marginTop:2}}>
                            <CardMedia
                                sx={{ height: 270 }}
                                image={items.img}
                                title={items.title}
                            />
                            <CardContent>
                                <Typography
                                    gutterBottom
                                    sx={{fontSize:"18px",fontWeight:"bold"}}
                                    variant="h6"
                                    component="div">
                                    {items.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    قیمت :  {items.price} تومان
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                      حداقل سفارش : {items.minorder} عدد
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button
                                    variant="contained"
                                    onClick={()=>{handle_btn_addtofactor(items.minorder , items.id , items.title)}}
                                    size="small">
                                    افزودن به فاکتور
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Dialog
                open={loading}
                scroll="paper">
                <CircularProgress sx={{margin:2}} />
            </Dialog>
            <Dialog
                open={dialogAddtofactor}
                onClose={()=>{setDialogAddtofactor(false)}}
                sx={{direction:"rtl"}}
                scroll="paper">
                <DialogContent dividers={'paper'}>
                    <DialogTitle id="alert-dialog-title">
                        <Typography sx={{color:"#000000"}}>{selectedTitle}</Typography>
                    </DialogTitle>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}>
                        <Box sx={{ width: '100%',direction:"rtl",minWidth:"250px" }}>
                            <ButtonGroup
                                fullWidth
                                variant="contained"
                                sx={{marginTop:3,direction:"ltr"}}
                                aria-label="outlined button group">
                                <Button
                                    onClick={()=>{setOrderCount(parseInt(orderCount) + parseInt(selectedCount) )}}>
                                    +
                                </Button>
                                <Button
                                    value
                                    disabled>
                                    {orderCount}</Button>
                                <Button
                                    onClick={handle_btn_decreas}>
                                    -
                                </Button>
                            </ButtonGroup>
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{setDialogAddtofactor(false)}}>بستن</Button>
                    <Button>افزودن به پیش فاکتور</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default Productlist;